export default () => {
  const hotspotButtons = document.querySelectorAll('.js-banner-hotspot');

  hotspotButtons.forEach((hotspotButton) => {
    hotspotButton.addEventListener('click', () => {
      const hotspot = hotspotButton.getAttribute('data-hotspot');

      const allHotspotProducts = document.querySelectorAll('.banner-hotspot__product');
      let hasActive = false;

      allHotspotProducts.forEach((allHotspotProduct) => {
        if (allHotspotProduct.classList.contains('active')) {
          hasActive = true;
        }

        if (hasActive) {
          if (allHotspotProduct.getAttribute('data-hotspot') !== `product-${hotspot}`) {
            allHotspotProduct.classList.remove('active');
          }
        }
      });

      const hotspotProducts = document.querySelectorAll(`[data-hotspot='product-${hotspot}']`);

      hotspotProducts.forEach((hotspotProduct) => {
        if (hotspotProduct.classList.contains('active')) {
          hotspotProduct.classList.remove('active');
        } else {
          hotspotProduct.classList.add('active');
        }
      });
    });
  });
};
